import React from 'react';
import SVG from 'react-inlinesvg';
import { useNavigate } from 'react-router-dom';
import { useSystemDevice } from '../../hooks/useSystemDevice';
import './Header.scss';

export default function Header({
  children,
  imageSrc,
}: {
  children: React.ReactNode;
  imageSrc: string;
}) {
  const scope = 'Header';
  const systemDevice = useSystemDevice();
  const navigate = useNavigate();
  const style = {
    backgroundImage: `url(${imageSrc})`,
  };

  return (
    <header className={`${scope} ${scope}--${systemDevice}`} style={style}>
      <div className={scope + '-content'}>
        <div className={scope + '-logo'}>
          <button
            className={scope + '-logoImageButton'}
            type="button"
            onClick={() => navigate('/')}
          >
            <SVG
              className={scope + '-logoImage'}
              src={`${process.env.PUBLIC_URL}/media/logo-white.svg`}
            />
          </button>
        </div>
        {children}
        <SVG
          className={`${scope}-downArrow`}
          src={`${process.env.PUBLIC_URL}/media/arrow-down.svg`}
        />
      </div>
    </header>
  );
}
